import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { navItems } from "../data/site";
import { Logo } from "./Logo";

export function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className="fixed inset-x-0 top-4 z-50 px-4 transition duration-300 sm:top-5"
    >
      <nav
        className={`mx-auto flex h-[4.75rem] w-full max-w-7xl items-center justify-between rounded-[1.75rem] border px-4 shadow-glass backdrop-blur-2xl transition duration-300 sm:px-5 lg:h-[4.85rem] lg:rounded-full lg:px-6 ${
          scrolled
            ? "border-white/[0.14] bg-ink/80"
            : "border-white/10 bg-white/[0.055]"
        }`}
        aria-label="Main navigation"
      >
        <Logo />
        <div className="hidden items-center gap-1 rounded-full border border-white/10 bg-ink/[0.38] p-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 text-sm font-medium transition ${
                  isActive
                    ? "bg-white/[0.12] text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.12)]"
                    : "text-white/65 hover:bg-white/[0.07] hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
        <div className="hidden items-center gap-3 lg:flex">
          <Link to="/contact" className="btn btn-primary">
            Start a Project
          </Link>
        </div>
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          className="grid h-11 w-11 place-items-center rounded-2xl border border-white/10 bg-white/[0.08] text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.08)] lg:hidden"
          aria-label={open ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={open}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>
      {open && (
        <div className="mx-auto mt-3 w-full max-w-7xl overflow-hidden rounded-[1.5rem] border border-white/10 bg-ink/92 p-3 shadow-glass backdrop-blur-2xl lg:hidden">
          <div className="grid gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.href}
                to={item.href}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-2xl px-4 py-3 text-sm font-medium ${
                    isActive
                      ? "bg-white/10 text-white"
                      : "text-white/70 hover:bg-white/5 hover:text-white"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="btn btn-primary mt-2 justify-center"
            >
              Start a Project
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
